import VueI18n from "vue-i18n";

const messages = {
  de: {
    'Ihr Suchprofil': 'Ihr Suchprofil',
    'Welche Immobilie suchen Sie?': 'Welche Immobilie suchen Sie?',
    'weiter': 'weiter',
    'zurück': 'zurück',
    'Formular abschicken': 'Formular abschicken',
    'Wohnen': 'Wohnen',
    'Gewerbe': 'Gewerbe',
    'Kaufen': 'Kaufen',
    'Mieten': 'Mieten',
    'haus': 'Haus',
    'wohnung': 'Wohnung',
    'grundstueck': 'Grundstück',
    'buero_praxis': 'Büro/Praxis',
    'einzelhandel': 'Einzelhandel',
    'hallen_lager': 'Hallen/Lager',
    'gastgewerbe': 'Gastgewerbe',
    'categoryMarketingTypeBUY': '{category} zum Kauf',
    'categoryMarketingTypeRENT': '{category} zur Miete',
    'marketingTypeBUY': 'Zum Kauf',
    'marketingTypeRENT': 'Zur Miete',
    'Kategorie': 'Kategorie',
    'Umkreis': 'Umkreis',
    'Stadt': 'Stadt',
    'Ortsteil': 'Ortsteil',
    'PLZ': 'PLZ',
    'Standort': 'Standort',
    'Straße': 'Straße',
    'Haus-Nr.': 'Haus-Nr.',
    'Anmeldung': 'Anmeldung',
    'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den': 'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den',
    'Anweisungen in der E-Mail': 'Anweisungen in der E-Mail',
    'Es ist ein Fehler aufgetreten.': 'Es ist ein Fehler aufgetreten.',
    'Bitte überprüfen Sie Ihre E-Mail-Adresse.': 'Bitte überprüfen Sie Ihre E-Mail-Adresse.',
    'Löschen': 'Löschen',
    'Bearbeiten': 'Bearbeiten',
    'Ihre gespeicherten Suchprofile': 'Ihre gespeicherten Suchprofile',
    'Suchanfragen': 'Suchanfragen',
    'Möchten Sie Ihr Suchprofil wirklich löschen?': 'Möchten Sie Ihr Suchprofil wirklich löschen?',
    'Speichern': 'Speichern',
    'Abbrechen': 'Abbrechen',
    "currencySymbol": "€",
    "wohnen": "Wohnen",
    "gewerbe": "Gewerbe",
    "kaufen": "Kaufen",
    "mieten": "Mieten",
    "fieldMin": "ab",
    "fieldMax": "bis",
    "fieldYes": "Ja",
    "fieldNo": "Nein",
    "Interessante Objekte": "Interessante Objekte ({n})",
    "Sie wurden abgemeldet": 'Sie wurden abgemeldet',
    'Seite neu laden.': 'Seite neu laden.',
    'userLogout': '{username} abmelden'
  }
};

const numberFormats = {
  de: {
    currency: {
      style: "currency", currency: "EUR", currencyDisplay: "symbol"
    },
    decimal: {
      style: "decimal"
    },
    int: {
      style: "decimal", maximumFractionDigits: 0, minimumFractionDigits: 0, useGrouping: false
    }
  }
};

export default {
  VueI18n: VueI18n,
  options: {
    locale: "de",
    messages: messages,
    numberFormats: numberFormats
  }
};
